import moment from 'moment';

export default (formValues, stepNum, marketingData, revisitingLead, highCourtLead, timeRunningOut) => {
  let data = {};

  switch (stepNum) {
    case 5:
      /* Accepted DBA */

      // // BELOW IS FOR TESTING STAGING
      // data.tags = ['p37GtgIcI', 'NlBqI6CDZ'];
      // data.custom_fields = [
      //   {
      //     id: 'YQ1SK6xOD',
      //     value: formValues.stp5_dbaAgreed.toString()
      //   },
      //   {
      //     id: 'jm_ouWMt9',
      //     value: formValues.stp5_dbaAgreedTS
      //   }  
      // ];

      // // to keep a record of everyone who has signed an anonymous DBA
      // if (revisitingLead) data.custom_fields.push({ id: 'ntAQTGeBT', value: 'Yes' })

      //BELOW IS FOR TESTING PRODUCTION
      data.tags = [process.env.REACT_APP_TAG_ACCEPTED_DBA_ID];
      data.custom_fields = [
        {
          id: process.env.REACT_APP_CF_DBA_AGREED_ID,
          value: formValues.stp5_dbaAgreed.toString()
        },
        {
          id: process.env.REACT_APP_CF_DBA_AGREED_DATE_ID,
          value: formValues.stp5_dbaAgreedTS
        }
      ];

      // to keep a record of everyone who has signed an anonymous DBA
      if (revisitingLead) data.custom_fields.push({ id: process.env.REACT_APP_CF_ANONYMOUS_DBA_ID, value: 'Yes'});
      return marketingData ? Object.assign(data, marketingData) : data;
    //default is the first POST
    default:
      /* Completed Initial Registration or High Court */

      // BELOW IS FOR TESTING STAGING
      // highCourtLead ? data.tags = ['_wt48_j4U'] : data.tags = ['8o9iqxdcy'];
      
      // data.custom_fields = [
      //   {
      //     id: 'Q6kwSLQdB',
      //     value: formValues.stp1_stillWorkThere
      //   },
      //   {
      //     id: 'LTYhPdtLX',
      //     value: formValues.stp1_endDate
      //   },
      //   {
      //     id: "U3xr_quJZ",
      //     value: formValues.stp1_storeDetails
      //   },
      //   {
      //     id: '-g7S2PBfq',
      //     value: formValues.stp1_hourlyWage
      //   },
      //   {
      //     id: '1-Longhq6',
      //     value: formValues.stp4_refSource
      //   },
      //   {
      //     id: 'sY_Nd1VKP',
      //     value: `Data permission agreed: ${formValues.stp4_consentPermission.toString()}`
      //   },
      //   {
      //    id: 'TKpVUK5YX',
      //    value: `Contact permission agreed: ${formValues.stp4_contactPermission.toString()}`
      //   }
      // ];

      // BELOW IS FOR TESTING PRODUCTION
      if (highCourtLead) {
        data.tags = [process.env.REACT_APP_TAG_HIGH_COURT_ID];
      } else if (timeRunningOut) {
        data.tags = [process.env.REACT_APP_TAG_COMPL_INIT_REG_TRO_ID];
      } else {
        data.tags = [process.env.REACT_APP_TAG_COMPL_INIT_REG_ID];
      };
      
      data.custom_fields = [
        {
          id: process.env.REACT_APP_CF_STILL_WORK_ID,
          value: formValues.stp1_stillWorkThere
        },
        {
          id: process.env.REACT_APP_CF_END_DATE_ID,
          value: formValues.stp1_endDate
        },
        {
          id: process.env.REACT_APP_CF_STORE_DETAILS_ID,
          value: formValues.stp1_storeDetails
        },
        {
          id: process.env.REACT_APP_CF_HOURLY_WAGE_ID,
          value: formValues.stp1_hourlyWage
        },
        {
          id: process.env.REACT_APP_CF_DATA_PERMISS_ID,
          value: `Data permission agreed: ${formValues.stp4_consentPermission.toString()}`
        },
        {
          id: process.env.REACT_APP_CF_CONTACT_PERMISS_ID,
          value: `Contact permission agreed: ${formValues.stp4_contactPermission.toString()}`
        },
        {
          id: process.env.REACT_APP_CF_NI_NUMBER_ID,
          value: formValues.stp3_nationalInsurance
        }
      ];

      return Object.assign(data, {
        address_postcode: formValues.stp2_postCode,
        address_street: `${formValues.stp2_houseNumName} ${formValues.stp2_streetRoad}`,
        address_location: formValues.stp2_town,
        address_country: formValues.stp2_country,
        first_name: formValues.stp3_firstName,
        last_name: formValues.stp3_lastName,
        email: formValues.stp3_emailAddress,
        phone: formValues.stp3_telephone,
        birthdate: moment(formValues.stp3_dob, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        gender: formValues.stp3_gender,
        //always send marketing data in initial POST
        ...marketingData
      });
  }
};
